export default {
    "Common.register": "register",
    "Common.or": "or",
}